angular.module('dpw.services')

    .factory('botProvisionService', [function () {
        return {
            appSourceGalleryUrl: 'http://appgallery',
            isServerBot: function (platformType) {
                return platformType === 'ServerBot';
            },
            isAppSourceGallery: function (appUrl) {
                return appUrl === this.appSourceGalleryUrl;
            }
        };
    }])

;